import { render, staticRenderFns } from "./kf-email.vue?vue&type=template&id=789d0ebe&scoped=true"
import script from "./kf-email.vue?vue&type=script&lang=js"
export * from "./kf-email.vue?vue&type=script&lang=js"
import style0 from "./kf-email.vue?vue&type=style&index=0&id=789d0ebe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "789d0ebe",
  null
  
)

export default component.exports